export var MessageType;
(function (MessageType) {
    // Auth
    MessageType[MessageType["AuthRequest"] = 1] = "AuthRequest";
    MessageType[MessageType["AuthResponse"] = 2] = "AuthResponse";
    // Player
    MessageType[MessageType["JoinGame"] = 10] = "JoinGame";
    MessageType[MessageType["LeaveGame"] = 11] = "LeaveGame";
    MessageType[MessageType["PlayerState"] = 12] = "PlayerState";
    MessageType[MessageType["PlayerDisconnected"] = 13] = "PlayerDisconnected";
    // Movement
    MessageType[MessageType["InputUpdate"] = 20] = "InputUpdate";
    MessageType[MessageType["EntityUpdate"] = 21] = "EntityUpdate";
    MessageType[MessageType["EntitySpawn"] = 22] = "EntitySpawn";
    MessageType[MessageType["EntityDespawn"] = 23] = "EntityDespawn";
    MessageType[MessageType["SectorChange"] = 24] = "SectorChange";
    // Combat
    MessageType[MessageType["FireWeapon"] = 30] = "FireWeapon";
    MessageType[MessageType["HitConfirm"] = 31] = "HitConfirm";
    MessageType[MessageType["DamageEvent"] = 32] = "DamageEvent";
    MessageType[MessageType["DeathEvent"] = 33] = "DeathEvent";
    MessageType[MessageType["RespawnRequest"] = 34] = "RespawnRequest";
    MessageType[MessageType["RespawnConfirm"] = 35] = "RespawnConfirm";
    // Resources
    MessageType[MessageType["MineAsteroid"] = 40] = "MineAsteroid";
    MessageType[MessageType["ResourceCollected"] = 41] = "ResourceCollected";
    MessageType[MessageType["InventoryUpdate"] = 42] = "InventoryUpdate";
    // Economy
    MessageType[MessageType["CraftItem"] = 50] = "CraftItem";
    MessageType[MessageType["BuyItem"] = 51] = "BuyItem";
    MessageType[MessageType["SellItem"] = 52] = "SellItem";
    MessageType[MessageType["TradeRequest"] = 53] = "TradeRequest";
    MessageType[MessageType["TradeResponse"] = 54] = "TradeResponse";
    MessageType[MessageType["MarketplaceList"] = 55] = "MarketplaceList";
    MessageType[MessageType["MarketplaceBuy"] = 56] = "MarketplaceBuy";
    // Merchant NPC trade (separate from station docking — ship stays in space)
    MessageType[MessageType["MerchantHail"] = 57] = "MerchantHail";
    MessageType[MessageType["MerchantOffer"] = 58] = "MerchantOffer";
    MessageType[MessageType["MerchantClose"] = 59] = "MerchantClose";
    // Stations
    MessageType[MessageType["DockRequest"] = 60] = "DockRequest";
    MessageType[MessageType["DockConfirm"] = 61] = "DockConfirm";
    MessageType[MessageType["UndockRequest"] = 62] = "UndockRequest";
    // Missions
    MessageType[MessageType["MissionList"] = 70] = "MissionList";
    MessageType[MessageType["MissionAccept"] = 71] = "MissionAccept";
    MessageType[MessageType["MissionProgress"] = 72] = "MissionProgress";
    MessageType[MessageType["MissionComplete"] = 73] = "MissionComplete";
    MessageType[MessageType["MissionAbandon"] = 74] = "MissionAbandon";
    /**
     * S→C: full snapshot of the pilot's completed-mission history (most
     * recent first, capped at 200 entries server-side). Sent on join and
     * after every new completion so the journal "Completed" tab always
     * reflects authoritative server state. Replaces the previous
     * client-only localStorage history that didn't survive a device
     * switch or a cleared browser profile.
     */
    MessageType[MessageType["MissionHistory"] = 75] = "MissionHistory";
    /**
     * C→S: one-shot migration aid sent on join when the client still has
     * a legacy localStorage completed-mission cache. The server merges
     * the entries into its persisted history ONLY when its own history
     * for this pilot is empty, then echoes the canonical snapshot back
     * via {@link MissionHistory}. After the round-trip the client wipes
     * its local cache and never sends this message again.
     */
    MessageType[MessageType["MissionHistorySeed"] = 76] = "MissionHistorySeed";
    // Social
    MessageType[MessageType["ChatSend"] = 80] = "ChatSend";
    MessageType[MessageType["ChatReceive"] = 81] = "ChatReceive";
    MessageType[MessageType["FleetInvite"] = 82] = "FleetInvite";
    MessageType[MessageType["FleetJoin"] = 83] = "FleetJoin";
    MessageType[MessageType["FleetLeave"] = 84] = "FleetLeave";
    MessageType[MessageType["FriendAdd"] = 85] = "FriendAdd";
    MessageType[MessageType["FriendAccept"] = 86] = "FriendAccept";
    MessageType[MessageType["DistressBeacon"] = 87] = "DistressBeacon";
    MessageType[MessageType["BountyPlace"] = 88] = "BountyPlace";
    MessageType[MessageType["LeaderboardRequest"] = 89] = "LeaderboardRequest";
    MessageType[MessageType["LeaderboardData"] = 90] = "LeaderboardData";
    /** C→S: reject an inbound friend request by id. */
    MessageType[MessageType["FriendReject"] = 91] = "FriendReject";
    /** C→S: drop an existing friendship. */
    MessageType[MessageType["FriendRemove"] = 92] = "FriendRemove";
    /** S→C: full snapshot of the pilot's friends list (sent on auth + after every change). */
    MessageType[MessageType["FriendsListData"] = 93] = "FriendsListData";
    /** S→C: pending in/out friend requests for this pilot. */
    MessageType[MessageType["FriendRequestsData"] = 94] = "FriendRequestsData";
    /** S→C: a single friend's online state changed (login / logout / disconnect). */
    MessageType[MessageType["FriendStatusUpdate"] = 95] = "FriendStatusUpdate";
    /** S→C: notification that an inbound friend request just arrived. */
    MessageType[MessageType["FriendRequestReceived"] = 96] = "FriendRequestReceived";
    // Progression
    MessageType[MessageType["XPGain"] = 100] = "XPGain";
    MessageType[MessageType["LevelUp"] = 101] = "LevelUp";
    MessageType[MessageType["SkillAllocate"] = 102] = "SkillAllocate";
    /**
     * Sector-wide broadcast emitted when any player levels up. Carries just
     * the entity id and new level — the self-targeted {@link LevelUp} still
     * carries the detailed stat snapshot. Used by the client to render the
     * FX on nearby players' ships.
     */
    MessageType[MessageType["PlayerLevelUpFx"] = 103] = "PlayerLevelUpFx";
    // World
    MessageType[MessageType["SectorData"] = 110] = "SectorData";
    MessageType[MessageType["SectorRequest"] = 111] = "SectorRequest";
    MessageType[MessageType["WarpGateUse"] = 112] = "WarpGateUse";
    MessageType[MessageType["DiscoveredSectors"] = 113] = "DiscoveredSectors";
    MessageType[MessageType["SectorDiscovered"] = 114] = "SectorDiscovered";
    MessageType[MessageType["WarpTravelResult"] = 115] = "WarpTravelResult";
    /**
     * Client → server: request to land on the planet the pilot is
     * currently orbiting. Server validates proximity and replies with a
     * {@link LandResultMsg}, then (on success) issues a normal
     * {@link SectorChangeMsg} with the surface sector id so the client
     * spins up its surface renderer.
     */
    MessageType[MessageType["LandRequest"] = 116] = "LandRequest";
    /** Server → client: result of a {@link LandRequestMsg}. */
    MessageType[MessageType["LandResult"] = 117] = "LandResult";
    /** Client → server: request to lift off back to orbit. */
    MessageType[MessageType["LiftoffRequest"] = 118] = "LiftoffRequest";
    /** Server → client: result of a {@link LiftoffRequestMsg}. */
    MessageType[MessageType["LiftoffResult"] = 119] = "LiftoffResult";
    /**
     * Server → client: full surface blueprint for the surface the pilot
     * just entered. Sent at most once per surface activation per session
     * — the client caches it for the duration of the session and uses
     * it to build the heightmap mesh, sky, and base placement.
     */
    MessageType[MessageType["SurfaceData"] = 122] = "SurfaceData";
    // Characters
    MessageType[MessageType["SaveCharacter"] = 120] = "SaveCharacter";
    MessageType[MessageType["DeleteCharacter"] = 121] = "DeleteCharacter";
    // Account lifecycle
    /**
     * Client → server: permanently delete the authenticated account and
     * every pilot / progression record attached to it. Required by the
     * App Store review guidelines (5.1.1(v)): an app that supports account
     * creation must let the user initiate account deletion from inside the
     * app. The client only sends this AFTER the player explicitly confirms
     * an irreversible-action warning dialog; the server still re-checks
     * that the session is authenticated before honouring it.
     */
    MessageType[MessageType["DeleteAccount"] = 123] = "DeleteAccount";
    /**
     * Server → client: acknowledgement that the account was deleted. The
     * server sends this right before it closes the socket so the client
     * can wipe its saved credentials and bounce back to the auth screen
     * with a confirmation banner instead of treating the close as an
     * involuntary disconnect.
     */
    MessageType[MessageType["AccountDeleted"] = 124] = "AccountDeleted";
    // Equipment
    MessageType[MessageType["EquipItem"] = 130] = "EquipItem";
    MessageType[MessageType["EquipmentUpdate"] = 131] = "EquipmentUpdate";
    // Consumables
    MessageType[MessageType["UseItem"] = 140] = "UseItem";
    MessageType[MessageType["ActiveBuffsUpdate"] = 141] = "ActiveBuffsUpdate";
    // Hangar (per-station ship garage)
    MessageType[MessageType["BuyShip"] = 150] = "BuyShip";
    MessageType[MessageType["SwitchShip"] = 151] = "SwitchShip";
    MessageType[MessageType["ShipHangarUpdate"] = 152] = "ShipHangarUpdate";
    // Per-pilot ship pattern + colors (premium cosmetic). Set is
    // client→server (validated server-side); Update is server→client
    // confirmation echoed after persistence so the picker UI can flip
    // back to the resolved cosmetics (which may differ from the
    // request when the server clamps a free pilot back to defaults).
    MessageType[MessageType["SetShipCosmetics"] = 153] = "SetShipCosmetics";
    MessageType[MessageType["ShipCosmeticsUpdate"] = 154] = "ShipCosmeticsUpdate";
    // Sector claims / sieges (player territory control)
    /**
     * Client → server: claim an unclaimed sector the pilot is currently
     * docked in. Server validates: docked at the sector station, no active
     * NPC garrison in range, sufficient credits, and that `dominantRace`
     * for the coord is `null` (so deep-lore sectors can never be seized).
     */
    MessageType[MessageType["ClaimSector"] = 155] = "ClaimSector";
    /**
     * Client → server: spend credits to bump the garrison level on a
     * sector the pilot already owns. Server enforces ownership + target
     * level == current+1 + credit cost.
     */
    MessageType[MessageType["ReinforceGarrison"] = 156] = "ReinforceGarrison";
    /**
     * Server → client: authoritative update for a single claim. Fired on
     * create, ownership transfer, garrison level change, and every siege
     * phase transition.
     */
    MessageType[MessageType["SectorClaimUpdate"] = 157] = "SectorClaimUpdate";
    /**
     * Server → client: granular siege tick update — intended for the
     * defender / attacker POV HUD banner. Carries `endsAt` so the client
     * can drive its own countdown without polling.
     */
    MessageType[MessageType["SiegeUpdate"] = 158] = "SiegeUpdate";
    /**
     * Server → client: full snapshot of all known claims in the session
     * cache. Sent once after the pilot authenticates so the universe map
     * and station UI boot with accurate ownership state.
     */
    MessageType[MessageType["SectorClaimsSnapshot"] = 159] = "SectorClaimsSnapshot";
    /**
     * Server → client: race-gated station shop catalogue for the station
     * the pilot just docked at. Carries per-item `price` already
     * discounted for the recipient (owners pay 10% less) so the client
     * doesn't need to re-derive discount math. Stock is `-1` (unlimited)
     * to match the merchant convention — scarcity is modelled by the
     * race gate, not per-item counters.
     */
    MessageType[MessageType["StationShopSnapshot"] = 161] = "StationShopSnapshot";
    // World events
    /**
     * Server → client global broadcast used by the scheduled event system
     * (mothership alerts, pirate raids, admin callouts, …). Carries a small
     * payload that the HUD surfaces as a flashing banner plus an entry in
     * the system chat log. Announcements are fire-and-forget — clients that
     * were offline when it fired do not receive it later.
     */
    MessageType[MessageType["SystemAnnouncement"] = 160] = "SystemAnnouncement";
    /**
     * Server → client: full snapshot of every world event that is
     * currently active and tied to a sector. Sent to a session right
     * after authentication so the warp-gate / universe-map indicators
     * paint the correct dots the first time the player opens them. The
     * payload is pre-localized to the recipient's session locale.
     */
    MessageType[MessageType["SectorEventsSnapshot"] = 165] = "SectorEventsSnapshot";
    /**
     * Server → client: incremental change to the active sector-event
     * set. Either `event` is set (a new active event was registered)
     * or `removedId` is set (an existing event expired or was cancelled).
     * Title / body are pre-localized to the recipient's locale.
     */
    MessageType[MessageType["SectorEventUpdate"] = 166] = "SectorEventUpdate";
    // Onboarding tutorial (per-player private sector)
    /**
     * Client → server: request to advance the onboarding state machine to
     * the named phase. The server validates the transition (e.g. `combat`
     * only after the player has destroyed all tutorial asteroids) and
     * responds with a {@link MessageType.TutorialPhase} echo carrying the
     * canonical phase the server actually entered. The `done` phase ends
     * the tutorial and teleports the player to sector 0,0,0.
     */
    MessageType[MessageType["TutorialAdvance"] = 170] = "TutorialAdvance";
    /**
     * Server → client: authoritative current phase of the onboarding flow
     * for this session. Sent on spawn (into the tutorial sector) and on
     * every phase change. The client drives its onboarding overlay from
     * this message; it must NOT advance phases on its own.
     */
    MessageType[MessageType["TutorialPhase"] = 171] = "TutorialPhase";
    /**
     * Server → client: notification fired when a destroyed NPC drops an
     * item (weapon / shield / engine / consumable) into the recipient's
     * inventory. The accompanying {@link InventoryUpdate} (and possibly
     * {@link EquipmentUpdate} for equipment) carries the actual stack
     * delta — this message is purely so the client can show a rich loot
     * toast with the item's icon, name, and rarity colour, and play a
     * "kill loot" sound. Only sent to the recipient — the rest of the
     * fleet learns about it via in-game chat / loot feeds at most.
     */
    MessageType[MessageType["NpcItemDrop"] = 180] = "NpcItemDrop";
    // Social — expanded comms window
    /**
     * Client → server: request the recent transcript for one chat thread
     * (Global, current Sector, or a Direct conversation with one pilot).
     * Used by the full-window chat UI so a freshly-connected player can
     * see the last messages exchanged before they logged in. Answered
     * with a {@link ChatHistoryData}.
     */
    MessageType[MessageType["ChatHistoryRequest"] = 181] = "ChatHistoryRequest";
    /** Server → client: response to a {@link ChatHistoryRequest}. */
    MessageType[MessageType["ChatHistoryData"] = 182] = "ChatHistoryData";
    /**
     * Client → server: request the public profile card for a pilot by
     * callsign (case-insensitive). Fired when a player clicks/taps a
     * name in the chat window. Answered with a {@link PlayerProfileData}.
     */
    MessageType[MessageType["PlayerProfileRequest"] = 183] = "PlayerProfileRequest";
    /** Server → client: response to a {@link PlayerProfileRequest}. */
    MessageType[MessageType["PlayerProfileData"] = 184] = "PlayerProfileData";
    // System
    MessageType[MessageType["Ping"] = 200] = "Ping";
    MessageType[MessageType["Pong"] = 201] = "Pong";
    // Account recovery (all usable BEFORE the session is authenticated)
    /** C→S: request a password-reset code to be emailed to the account. */
    MessageType[MessageType["PasswordResetRequest"] = 210] = "PasswordResetRequest";
    /** C→S: redeem an emailed reset code and set a new password. */
    MessageType[MessageType["PasswordResetConfirm"] = 211] = "PasswordResetConfirm";
    /** S→C: outcome of either password-reset step. */
    MessageType[MessageType["PasswordResetResult"] = 212] = "PasswordResetResult";
    // Player marketplace (cross-pilot escrowed item listings)
    /** S→C: snapshot of a marketplace page (`scope: 'all' | 'mine'`). */
    MessageType[MessageType["MarketplaceListings"] = 230] = "MarketplaceListings";
    /** C→S: post a new listing (item + qty + price/unit). */
    MessageType[MessageType["MarketplaceCreate"] = 231] = "MarketplaceCreate";
    /** C→S: cancel an own listing (escrowed items are returned). */
    MessageType[MessageType["MarketplaceCancel"] = 232] = "MarketplaceCancel";
    /** S→C: result of the last marketplace mutation (created/bought/cancelled/sold/failed). */
    MessageType[MessageType["MarketplaceResult"] = 233] = "MarketplaceResult";
    /** S→C: notify the seller their listing was bought (push update). */
    MessageType[MessageType["MarketplaceSold"] = 234] = "MarketplaceSold";
    /**
     * Server → client: live premium subscription update. Pushed by the
     * billing webhook handler whenever Stripe fires `customer.subscription.*`
     * or `checkout.session.completed` for the recipient's account so the
     * client can flip the locked race cards / pause-menu UPGRADE button
     * the moment payment lands, without forcing a re-login.
     */
    MessageType[MessageType["PremiumUpdate"] = 240] = "PremiumUpdate";
    /**
     * Server → client: full snapshot of the inter-station bounty board.
     * Pushed on auth, on every successful dock, when the
     * `bounty_board_refresh_30m` scheduled event refreshes the contract
     * pool, and after a contract is claimed (so every viewer sees the
     * row disappear in real time). Keeps clients stateless about the
     * board — they just render whatever the latest snapshot carries.
     */
    MessageType[MessageType["BountyBoardData"] = 250] = "BountyBoardData";
    /**
     * Client → server: hold-to-investigate a surface ruin. Sent once
     * by the client after KeyE has been held for the full investigate
     * timer (3 s) while inside the ruin's radius. Server validates
     * proximity + sector + on-surface, then unlocks the codex
     * fragment (Phase 2.3), grants a small loot drop and acks via
     * {@link InvestigateRuinResult}.
     */
    MessageType[MessageType["InvestigateRuin"] = 251] = "InvestigateRuin";
    /** Server → client: response to {@link InvestigateRuin}. */
    MessageType[MessageType["InvestigateRuinResult"] = 252] = "InvestigateRuinResult";
    /**
     * Server → client: list of codex fragments the pilot has just
     * unlocked. Fired by ruin investigation, mission completion,
     * weather survival, etc. The client merges these into the
     * persisted unlocked set and re-renders the codex tab.
     */
    MessageType[MessageType["CodexUnlock"] = 253] = "CodexUnlock";
    /**
     * Server → client: current weather state for the surface sector
     * the pilot is on. Broadcast once per state change so the HUD
     * banner reflects the active event without polling.
     */
    MessageType[MessageType["SurfaceWeather"] = 254] = "SurfaceWeather";
    /**
     * Server → client: per-planet reputation snapshot or single-surface
     * delta (Phase 3.2). The dock UI renders a meter for the current
     * surface; the HUD toasts the delta amount.
     */
    MessageType[MessageType["PlanetReputationUpdate"] = 235] = "PlanetReputationUpdate";
    /**
     * Server → client: set of surface ids the pilot has liberated
     * (Phase 3.3 — Liberate the World arc). Cosmetic + UI badge driver.
     */
    MessageType[MessageType["LiberatedSurfaces"] = 236] = "LiberatedSurfaces";
    MessageType[MessageType["Error"] = 255] = "Error";
})(MessageType || (MessageType = {}));
//# sourceMappingURL=messages.js.map